import {axios} from "../../core";

export default {
    signUp: postData => axios.post("/user/sign-up", postData),
    getMe: () => axios.get("/user/me"),
};
